import { LocalizedLink as Link } from '../../../components/LocalizedLink';
import { useTranslation } from 'react-i18next';

const Portfolio = () => {
  const { t } = useTranslation();
  const projects = [
    {
      id: 8,
      title: "Runa",
      category: "Digital Experience",
      image: "/assets/images/portfolio/runahr/cover.webp",
      link: "/portfolio/runahr",
      type: 'web',
      bgGradient: 'from-blue-600 to-blue-400'
    },
    {
      id: 9,
      title: "Wide Angle",
      category: "Website",
      image: "/assets/images/portfolio/wide-angle/cover.webp",
      link: "/portfolio/wide-angle",
      type: 'web',
      bgGradient: 'from-pink-600 to-rose-400'
    },
    {
      id: 10,
      title: "Cachalo y Gana",
      category: "Digital PLatform",
      image: "/assets/images/portfolio/cachalo-y-gana/cover.webp",
      link: "/portfolio/cachalo-y-gana",
      type: 'web',
      bgGradient: 'from-orange-500 to-amber-400'
    },
    {
      id: 11,
      title: "Xcape",
      category: "Digital Platform",
      image: "/assets/images/portfolio/xcape/cover.webp",
      link: "/portfolio/xcape",
      type: 'web',
      bgGradient: 'from-teal-500 to-emerald-400'
    },
    {
      id: 3,
      title: "Mia Astral",
      category: "Digital Ecosystem",
      image: "/assets/images/portfolio/caso-de-exito-mia.png",
      link: "/portfolio/mia-astral",
      bgGradient: 'from-purple-600 to-indigo-500'
    },
    {
      id: 6,
      title: "PFS Realty",
      category: "Real Estate Platform",
      image: "/assets/images/portfolio/pfsrealty/cover.webp",
      link: "/portfolio/pfs-realty",
      type: 'web',
      bgGradient: 'from-sky-600 to-blue-500'
    },
    {
      id: 1,
      title: "Erika de la Vega",
      category: "Podcast & Web",
      image: "/assets/images/portfolio/caso-de-exito-erika-1.png",
      link: "/portfolio/erika-de-la-vega"
    },
    {
      id: 2,
      title: "Ismael Cala",
      category: "E-commerce",
      image: "/assets/images/portfolio/caso-de-exito-cala3-1.png",
      link: "/portfolio/ismael-cala"
    },
    {
      id: 4,
      title: "Foto Ahora",
      category: "Digital Service",
      image: "/assets/images/portfolio/tapa-fotoahora-2-1200x1200.jpg",
      link: "/portfolio/foto-ahora"
    },
    {
      id: 5,
      title: "Nawis App",
      category: "Mobile App",
      image: "/assets/images/portfolio/tapa.jpg",
      link: "/portfolio/nawis"
    },
    {
      id: 7,
      title: "Yogurt Boom",
      category: "Branding & Web",
      image: "/assets/images/portfolio/yogurt-boom/cover.png",
      link: "/portfolio/yogurt-boom"
    }
  ];

  return (
    <section className="py-32 px-2 md:px-10 bg-white border-t border-gray-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-end justify-between mb-20">
          <div>
            <span className="font-display text-[10px] tracking-[0.4em] text-gray-400 uppercase mb-4 block">
              {t('portfolio.subtitle')}
            </span>
            <h2 className="font-display text-4xl md:text-7xl font-bold text-gray-900 uppercase tracking-tighter">
              {t('portfolio.title')}<br />
              <span className="text-gray-400 italic">{t('portfolio.highlight')}</span>
            </h2>
          </div>
          <div className="hidden md:block text-right">
            <p className="font-sans text-gray-400 max-w-[200px] text-[10px] leading-relaxed uppercase tracking-[0.2em]">
              {t('portfolio.description')}
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-16 md:gap-24">
          {projects.map((project, index) => (
            <Link
              key={project.id}
              to={project.link}
              className={`group relative flex flex-col ${
                index === 0 ? 'md:col-span-2' : ''
              }`}
            >
              <div className={`relative overflow-hidden flex items-center justify-center ${
                project.type === 'web' 
                ? `bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] ${project.bgGradient || 'from-gray-100 to-white'} p-4 md:p-8 rounded-2xl shadow-inner` 
                : 'bg-gray-50'
              } ${
                index === 0 
                ? 'aspect-video md:h-[700px]' 
                : 'aspect-[4/5] md:h-[600px]'
              }`}>
                {project.type === 'web' ? (
                  <div className={`relative w-full aspect-video bg-white rounded-xl shadow-2xl overflow-hidden border border-gray-200/50 transition-all duration-700 ease-out group-hover:shadow-gray-300/50 flex flex-col ${
                    index !== 0 ? 'group-hover:scale-105' : ''
                  }`}>
                    {/* Browser Header */}
                    <div className="h-6 md:h-8 bg-gray-50 border-b border-gray-100 flex items-center px-4 gap-1.5 shrink-0">
                      <div className="w-2 h-2 rounded-full bg-red-400/50"></div>
                      <div className="w-2 h-2 rounded-full bg-amber-400/50"></div>
                      <div className="w-2 h-2 rounded-full bg-emerald-400/50"></div>
                      <div className="ml-4 h-3 md:h-4 w-32 md:w-48 bg-gray-200/50 rounded-full"></div>
                    </div>
                    {/* Website Image */}
                    <div className="flex-1 overflow-hidden relative">
                      <img
                        src={project.image}
                        alt={project.title}
                        className="w-full h-full object-cover object-top"
                      />
                    </div>
                  </div>
                ) : (
                  <img
                    src={project.image}
                    alt={project.title}
                    className={`w-full h-full object-cover rounded-2xl transition-transform duration-700 ${
                      index !== 0 ? 'group-hover:scale-105' : ''
                    }`}
                  />
                )}
              </div>
              
              <div className="mt-8 flex items-start justify-between border-b border-gray-100 pb-8">
                <div>
                  <h3 className="font-display text-4xl font-bold text-gray-900 uppercase tracking-tight group-hover:italic transition-all duration-300">
                    {project.title}
                  </h3>
                  <p className="font-display text-[10px] tracking-[0.2em] text-gray-400 uppercase mt-2">
                    {project.category}
                  </p>
                </div>
                <div className="w-12 h-12 rounded-full border border-gray-200 flex items-center justify-center group-hover:bg-gray-900 group-hover:border-gray-900 transition-all duration-300">
                  <i className="ri-arrow-right-up-line text-2xl text-gray-900 group-hover:text-white"></i>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Portfolio;
